import { render, staticRenderFns } from "./addClueOrder.vue?vue&type=template&id=19610b85&"
import script from "./addClueOrder.vue?vue&type=script&lang=js&"
export * from "./addClueOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports